import {theme} from './theme'

// stylelint-disable max-nesting-depth -- We need nesting here
import {createGlobalStyle, css} from 'styled-components';

export const svgIconHoverClassName = "svg-icon-hover"
export const svgIconGrayClassName = "svg-icon-gray"
export const svgNoShrinkClassName = "svg-no-shrink"
export const svgPointerClassName = "svg-pointer"

// A thin rounded scrollbar: a yellow thumb on a light grey track
export const thinScrollbarCss = css`
    /* Chrome ignores the ::-webkit-scrollbar styles when scrollbar-color is set, and html sets it */
    scrollbar-color: auto;
    ::-webkit-scrollbar {
      inline-size: 4px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 999px;
      background-color: rgb(227 227 227 / 50%); /* MediumGrey at 50% opacity */
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 999px;
      background-color: ${theme.colors.MainYellow};
    }
    /* Browsers without ::-webkit-scrollbar (Firefox) */
    @supports not selector(::-webkit-scrollbar) {
      scrollbar-width: thin;
      scrollbar-color: ${theme.colors.MainYellow} rgb(227 227 227 / 50%);
    }
`
export const selectSvgIconClassName = "svg-select-grey"

const GlobalStyle = createGlobalStyle`
    * {
      scroll-behavior: smooth;
    }
    [hidden] {
      display: none;
    }
    /* https://web.dev/accent-color/ */
    html {
      --brand: ${theme.colors.MainYellow};
      scrollbar-color: ${theme.colors.bodyBg};
    }
    /* https://www.smashingmagazine.com/2021/09/simplifying-form-styles-accent-color/ */
    :root {
      accent-color: var(--brand);
    }
    :focus-visible {
      outline-color: var(--brand);
    }
    ::selection {
      color: ${theme.colors.White};
      background-color: var(--brand);
    }
    ::marker {
      color: var(--brand);
    }
    :is(::-webkit-calendar-picker-indicator, ::-webkit-clear-button, ::-webkit-inner-spin-button, ::-webkit-outer-spin-button) {
      color: var(--brand);
    }
    html,
    body,
    div[id='root'] {
      display: block;
      block-size: 100%;
    }
    body {
      margin: 0;
      overflow-y: overlay;
      caret-color: ${theme.colors.MainBlack};
      color: ${theme.colors.body};
      font-family: ${theme.fonts.body};
      font-size: ${theme.fontSizes.body};
      line-height: ${theme.lineHeights.normal};
      background-color: ${theme.colors.bodyBg};
    }
    a,
    button {
      transition: all ${theme.transitions.normal} ease-out;
      :hover {
        cursor: pointer;
        color: ${theme.colors.bodyHover};
      }
      :focus {
        color: ${theme.colors.bodyHover};
      }
    }
    code {
      font-family: 'source-code-pro', 'Menlo', 'Monaco', 'Consolas', 'Courier New', monospace;
    }
    
    .${svgIconHoverClassName} {
      flex-shrink: 0;
      margin: var(--size, 0.5em);
      min-block-size: var(--size, 1em);
      min-inline-size: var(--size, 1em);
      fill: var(--color, currentColor);
      stroke: var(--color, currentColor);
    }
    
    .${svgIconGrayClassName} {
      flex-shrink: 0;
      /* This changes the SVG color to grey - https://stackoverflow.com/a/53336754/4574731 */
      // filter: invert(32%) sepia(0%) saturate(21%) hue-rotate(213deg) brightness(105%) contrast(91%);
    }

    .${svgNoShrinkClassName} {
      flex-shrink: 0;
    }

    .${svgPointerClassName} {
      cursor: pointer;
    }

    .${selectSvgIconClassName} {
        flex-shrink: 0;
        /* This changes the SVG color to grey - https://stackoverflow.com/a/53336754/4574731 - TODO: change to fill/stroke */
        // filter: invert(32%) sepia(0%) saturate(21%) hue-rotate(213deg) brightness(105%) contrast(91%);
    }

    .mapMarkerSvg {
      display: block;
    }
`;

export default GlobalStyle;
